import { Divider, YStack, useWebExpressCheckout } from '@frontend/web-react';
import { stripeExpressCheckoutOptions } from '@frontend/web/components';
import { ExpressCheckoutElement } from '@stripe/react-stripe-js';

type PaywallExpressCheckoutProps = {
  clientSecret: MaybeUndefined<string>;
  onComplete: (setupIntentId: string) => Promise<boolean>;
};

export const PaywallExpressCheckout = ({ clientSecret, onComplete }: PaywallExpressCheckoutProps) => {
  const { isAvailable, onConfirm, onReady } = useWebExpressCheckout({ clientSecret, onComplete });

  if (!isAvailable) return null;

  return (
    <YStack gapY="md">
      <ExpressCheckoutElement onConfirm={onConfirm} onReady={onReady} options={stripeExpressCheckoutOptions} />
      <Divider label="Or pay with card" labelPosition="center" />
    </YStack>
  );
};
